/*
  Raving Room: <card-media-slider> — drives the progress bar of the collection
  product-card image slider. The black fill widens as you scroll through the
  photos (fill = (scrollLeft + clientWidth) / scrollWidth). No arrows; swipe/scroll
  is native via CSS scroll-snap. Re-upgrades automatically when the grid re-renders
  through the Section Rendering API.
*/
if (!customElements.get('card-media-slider')) {
  customElements.define(
    'card-media-slider',
    class CardMediaSlider extends HTMLElement {
      connectedCallback() {
        this.track = this.querySelector('.card-media-slider__track');
        this.fill = this.querySelector('.card-media-slider__progress span');
        if (!this.track || !this.fill) return;

        this.onScroll = this.onScroll.bind(this);
        this.track.addEventListener('scroll', this.onScroll, { passive: true });
        // Initial state (fill = one photo's worth: clientWidth / scrollWidth).
        requestAnimationFrame(() => this.update());
      }

      disconnectedCallback() {
        if (this.track) this.track.removeEventListener('scroll', this.onScroll);
      }

      onScroll() {
        if (this.raf) return;
        this.raf = requestAnimationFrame(() => {
          this.raf = null;
          this.update();
        });
      }

      update() {
        const { scrollLeft, clientWidth, scrollWidth } = this.track;
        if (!scrollWidth) return;
        const pct = Math.min(100, ((scrollLeft + clientWidth) / scrollWidth) * 100);
        this.fill.style.width = pct + '%';
      }
    }
  );
}
